function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#5F37FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7805 14.3856L15.9321 9.30666C16.0559 9.10713 16.0057 8.83755 15.82 8.70453C15.7536 8.65698 15.6756 8.63161 15.5958 8.63161H13.1178V5.4342C13.1178 5.1944 12.9369 5 12.7137 5C12.5785 5 12.4523 5.07256 12.3774 5.19335L9.22581 10.2723C9.102 10.4718 9.15219 10.7414 9.3379 10.8744C9.40429 10.922 9.48229 10.9473 9.56208 10.9473H12.0401V14.1447C12.0401 14.3845 12.221 14.5789 12.4442 14.5789C12.5794 14.5789 12.7055 14.5064 12.7805 14.3856Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.05263 6.3C5.05263 5.88433 5.3896 5.54737 5.80526 5.54737H9.08947C9.50514 5.54737 9.84211 5.88433 9.84211 6.3C9.84211 6.71567 9.50514 7.05263 9.08947 7.05263H5.80526C5.3896 7.05263 5.05263 6.71567 5.05263 6.3Z",
  fill: "white"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 9.72105C3 9.30539 3.33696 8.96842 3.75263 8.96842H7.03684C7.45251 8.96842 7.78947 9.30539 7.78947 9.72105C7.78947 10.1367 7.45251 10.4737 7.03684 10.4737H3.75263C3.33696 10.4737 3 10.1367 3 9.72105Z",
  fill: "white"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.05263 13.1421C5.05263 12.7264 5.3896 12.3895 5.80526 12.3895H9.08947C9.50514 12.3895 9.84211 12.7264 9.84211 13.1421C9.84211 13.5578 9.50514 13.8947 9.08947 13.8947H5.80526C5.3896 13.8947 5.05263 13.5578 5.05263 13.1421Z",
  fill: "white"
});

var SvgRatingsPageMobileNav = function SvgRatingsPageMobileNav(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRatingsPageMobileNav, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RatingsPageMobileNav.259d44ad.svg";
export { ForwardRef as ReactComponent };